import * as types from "../types/pageTypes";

const initialState = {
  currentlyPlaying: false,
  winWidth: 0
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SET_PLAYING:
      return {
        ...state,
        currentlyPlaying: action.currentlyPlaying
      };
    default:
      return state;
  }
};
